module.exports = new __parcel__URL__("azure.4903977c.png").toString();